<ng-content></ng-content>

<mat-icon svgIcon="lock" class="lock-icon" [class.hidden]="lockIconHidden$ | async" #lockIcon></mat-icon>
